<template>
  <div id="menu-std" name="menu-std" class="menu-std">
    <div class="heading">Components</div>
    <ul class="menu-panel">
      <li class="menu" :class="{ '-active' : exButtonActive }" @click="togglePage('exButtonActive')">Button</li>
      <li class="menu" :class="{ '-active' : exButtonGroupActive }" @click="togglePage('exButtonGroupActive')">Button Group</li>
      <li class="menu" :class="{ '-active' : exCollapseActive }" @click="togglePage('exCollapseActive')">Collapse</li>
      <li class="menu" :class="{ '-active' : exDropdownActive }" @click="togglePage('exDropdownActive')">Dropdown Menu</li>
      <li class="menu" :class="{ '-active' : exCheckboxActive }" @click="togglePage('exCheckboxActive')">Form Checkbox</li>
      <!-- <li class="menu" :class="{ '-active' : exFileActive }" @click="togglePage('exFileActive')">Form File</li> -->
      <li class="menu" :class="{ '-active' : exInputActive }" @click="togglePage('exInputActive')">Form Input</li>
      <!-- <li class="menu" :class="{ '-active' : exInputGroupActive }" @click="togglePage('exInputGroupActive')">Form Input Group</li> -->
      <li class="menu" :class="{ '-active' : exRadioActive }" @click="togglePage('exRadioActive')">Form Radio</li>
      <li class="menu" :class="{ '-active' : exSelectActive }" @click="togglePage('exSelectActive')">Form Select</li>
      <li class="menu" :class="{ '-active' : exModalActive }" @click="togglePage('exModalActive')">Modal</li>
      <!-- <li class="menu" :class="{ '-active' : exPopoverActive }" @click="togglePage('exPopoverActive')">Popover</li> -->
      <li class="menu" :class="{ '-active' : exTabActive }" @click="togglePage('exTabActive')">Tab</li>
      <!-- <li class="menu" :class="{ '-active' : exTooltipActive }" @click="togglePage('exTooltipActive')">Tooltip</li> -->
    </ul>
    
  </div>
</template>

<script>
  export default {
    name: 'menu-std',
    props: [ 'togglePage', 'exButtonActive', 'exButtonGroupActive', 'exCollapseActive', 'exDropdownActive', 'exCheckboxActive', 'exInputActive', 'exRadioActive', 'exSelectActive', 'exModalActive', 'exTabActive' ]
  }
</script>


// WEBPACK FOOTER //
// menu.vue?2d3f79bc